import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DarDossiersService} from '../../common/services/dossiers/dossiers.service';
import {PopulationEnum} from '../../common/services';
import {Dossiers, fileTypeEnumLabel, StateEnum} from '../../common/services';
import { MatAccordion } from '@angular/material/expansion';

import {Observable} from 'rxjs';
import {FilesUtils, IndividuService} from '@Common/core/services';

import {RemunerationEnum} from '../../common/services/enums/remunerationEnum';
import {PieceJointe} from '../../common/services/pieces-jointes/piece-jointe.model';
import {PiecejointeService} from '../../common/services/pieces-jointes/piecejointe.service';
import {DossierValidator} from '../../gestion/common/DossierValidator';
import {SubSink} from '@Common/core/utils/subsink';
import {finalize} from 'rxjs/operators';
import {SlugifyPipe} from "@Common/widgets/pipes";
import {saveAs} from "file-saver";
import {MatDrawer} from "@angular/material/sidenav";


@Component({
  selector: 'app-dar-consultation',
  templateUrl: './consultation.component.html',
  styleUrls: ['./consultation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ConsultationComponent extends DossierValidator implements OnInit, OnDestroy {
  @Input() dossierId = null;
  @Input() byModal = false;
  @Output() dossierLoaded = new EventEmitter<Dossiers>();

  @ViewChild('accordeon', { static: true }) accordeon: MatAccordion;
  @ViewChild('ctsread', { static: true }) ctsread: MatDrawer;

  openComment = false;

  toggleOpenCloseLabel = true;
  populationEnum = PopulationEnum;
  remunerationEnum = RemunerationEnum;

  dossier: Dossiers = <Dossiers>{};

  types_demandes: any[] = [];
  remunerations: any[] = [];
  subSink = new SubSink();
  loadingDossier = false;


  statesAfterDrh: StateEnum[] = [
    StateEnum.commission, StateEnum.commission_decision,
    StateEnum.spta, StateEnum.spta_traitement,
    StateEnum.spte,
    StateEnum.recrutement, StateEnum.publication,
    StateEnum.recrutement_spte,
    StateEnum.refus, StateEnum.clos];

  constructor(private activatedRoute: ActivatedRoute,
              public individuSvc: IndividuService,
              public dossierService: DarDossiersService,
              private pieceJointeService: PiecejointeService,
              private fileUtils: FilesUtils) {
    super(dossierService, individuSvc);
  }

  ngOnInit() {
    const id = this.activatedRoute.snapshot.params['id'] || this.dossierId;
    this.openComment = this.activatedRoute.snapshot.params['openComment'] ?? false;
    if (id && id.match('^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12}$')) {
      this.loadingDossier = true;
      this.types_demandes = this.dossierService.getTypesDemandes();
      this.remunerations = this.dossierService.getRemunerations();
      this.subSink.sink = this.dossierService
        .get(id)
        .pipe(finalize(() => this.loadingDossier = false))
        .subscribe((dossier: Dossiers) => {
          this.dossier = dossier;
          this.dossier.type_demande_obj = this.types_demandes.filter(x => x.id === dossier.type_demande)[0];
          this.dossier.remuneration_obj = this.remunerations.filter(x => x.id === dossier.remuneration)[0];
          this.dossierLoaded.emit(this.dossier);
          if (this.openComment) {
            this.ctsread.toggle();
          }
        });
    }

    this._initHasRole();
  }

  /**
   * Affichage commentaires selon role et paramétre optionnel byModal
   */

  showComments(): Observable<boolean> {
    return this.shouldShowComments(this.dossier);
  }

  ifAfterDRh(state: StateEnum) {
    return this.statesAfterDrh.some((_state) => _state === state);
  }

  /**
   * Tri par le type de pièces jointes et les renvoi pour affichage
   */
  getPieceJointes() {
    if (this.dossier.attachedfiles_obj && this.dossier.attachedfiles_obj.length > 0) {
      const pjs = this.dossier.attachedfiles_obj;
      pjs.sort((a: PieceJointe, b: PieceJointe) =>  (a.type_file > b.type_file) ? 1 : ((b.type_file > a.type_file) ? -1 : 0));
      return pjs;
    }

    return this.dossier.attachedfiles_obj;
  }

  /**
   * Télécharge d'un PJ
   * @param $event
   * @param {PieceJointe} file : le fichier à télécharger
   */
  onDownload($event, file: PieceJointe) {
    this.pieceJointeService.download(file);
  }

  getPicto(file) {
    return this.fileUtils.getPictoFromExtension(file);
  }

  getLabelButton(file) {
    const typeFile = fileTypeEnumLabel(file.type_file);
    return `${typeFile} : télécharger le fichier "${file.name}"`;
  }

  getReference() {
    return this.dossier.reference ? `Consultation du dossier ${this.dossier.reference}` : '#';
  }

  getButtonOpenCloseLabel() {
    if (this.toggleOpenCloseLabel) {
      return 'Ouvrir toutes les sections';
    }

    return 'Fermer toutes les sections';
  }

  openAccordion(event) {
    if (this.toggleOpenCloseLabel) {
      this.accordeon.openAll();
    } else {
      this.accordeon.closeAll();
    }

    this.toggleOpenCloseLabel = ! this.toggleOpenCloseLabel;
  }
  exportZipAttachementsDar(dossier: Dossiers) {
    this.loadingDossier = true;
    this.subSink.sink = this.dossierService
      .exportPdfDemandeur(dossier, 'zip')
      .pipe(finalize(() => this.loadingDossier = false))
      .subscribe((data: Blob) => {
        const slug = new SlugifyPipe();
        const ref = slug.transform(dossier.reference, 'upper');
        const zipFileName = `EXPORT_DEMANDE_DAR_${ref}.zip`;
        saveAs(data, zipFileName);
      });
  }

  hiddeButtonZip(dossier: Dossiers): boolean {
    return dossier.attachedfiles_obj?.length > 0;
  }

  /**
   * Nb jours entre 2 dates
   * @param {Date} dateDebut
   * @param {Date} dateFin
   * @param {boolean} included : date début incluse, par défaut oui
   */
  getDaysBetweenDates(dateDebut: string, dateFin: string, included = true) {
    const dateD = this.getDateFromString(dateDebut);
    const dateF = this.getDateFromString(dateFin);

    const oneDay = 1000 * 60 * 60 * 24;
    const diffDates = dateF.getTime() - dateD.getTime();

    let nbDays = Math.round(diffDates / oneDay);

    if (included) {
      nbDays += 1;
    }

    return nbDays;
  }

  getDateFromString(dt: string) {
    let dtReturn = null;

    if (dt) {
      const splitDt = dt.split('-');

      dtReturn = new Date(Number(splitDt[0]), Number(splitDt[1]), Number(splitDt[2]));
    }

    return dtReturn;
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
